// extracted by mini-css-extract-plugin
module.exports = {"errorText":"incoming_errorText__1ybLH","containing":"incoming_containing__3iZXY","tabs":"incoming_tabs__Rerbb"};